import { useCallback } from "react";
import type { TimelineItemResponseDTO as TimelineItem } from "web_myplann/Infrastructure/Api/Api";
import {
	type UsePerformTimelineNavigationOptions,
	usePerformTimelineNavigation,
} from "web_myplann/NotificationCenter/Hooks/usePerformTimelineNavigation";
import { resolveTimelineNavigation } from "web_myplann/NotificationCenter/Utils/resolveTimelineNavigation";

export type UseNavigateFromTimelineItemOptions =
	UsePerformTimelineNavigationOptions;

export const useNavigateFromTimelineItem = (
	options?: UseNavigateFromTimelineItemOptions,
): ((item: TimelineItem) => void) => {
	const performNavigation = usePerformTimelineNavigation(options);

	return useCallback(
		(item: TimelineItem) => {
			const navigation = resolveTimelineNavigation(item);
			if (navigation) {
				performNavigation(navigation);
			}
		},
		[performNavigation],
	);
};
